import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

// ==============================|| PROTECTED ROUTE ||============================== //
// Checks auth synchronously via localStorage before rendering any protected UI.
// Also listens to storage, focus, and pageshow events to handle bfcache (back-forward cache)
// and manual token deletion across tabs.

export default function ProtectedRoute({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('token') || sessionStorage.getItem('token'));

  useEffect(() => {
    const checkToken = () => {
      const currentToken = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (currentToken !== token) {
        setToken(currentToken);
      }
    };

    // Listen to changes from other tabs or local updates
    window.addEventListener('storage', checkToken);
    // Listen to tab focus/active state
    window.addEventListener('focus', checkToken);
    // Listen to browser back/forward cache (bfcache) restore
    window.addEventListener('pageshow', checkToken);

    return () => {
      window.removeEventListener('storage', checkToken);
      window.removeEventListener('focus', checkToken);
      window.removeEventListener('pageshow', checkToken);
    };
  }, [token]);

  if (!token) {
    // Redirect to login instantly
    return <Navigate to="/login" replace />;
  }

  return children;
}
